const decoder = new TextDecoder();

export default class DataChannelWrapper {
	constructor(channel, callback) {
		// Listen for data on the data channel (this is where screenshots will be sent through by the student)
		this.terminator = "\0".charCodeAt(0);
		this.screenshotChunks = [];

		this.channel = channel;
		this.messageReceived = callback;

		channel.addEventListener("message", this.onDataChannelMessage);
	}

	onDataChannelMessage = (msg) => {
		const data = new Uint8Array(msg.data);

		if (this.isTerminated(data)) {
			const chunk = data.subarray(0, data.length - 2);
			this.screenshotChunks.push(chunk);

			const totalLength = this.screenshotChunks.reduce((acc, chunk) => acc + chunk.length, 0);

			const combined = new Uint8Array(totalLength);
			let offset = 0;
			this.screenshotChunks.forEach((chunk) => {
				combined.set(chunk, offset);
				offset += chunk.length;
			});

			this.screenshotChunks.length = 0;

			try {
				const decodedMessage = JSON.parse(decoder.decode(combined));
				this.messageReceived(decodedMessage);
			} catch (e) {
				if (e instanceof SyntaxError) {
					console.error("Known issue encountered with screenshot chunks, skipping screenshot");
					return;
				} else {
					throw e;
				}
			}
		} else {
			this.screenshotChunks.push(data);
		}
	};

	isTerminated = (data) => {
		return data[data.length - 1] === this.terminator && data[data.length - 2] === this.terminator;
	};

	removeListeners(event, callback) {
		this.channel.removeEventListener("message", this.onDataChannelMessage);
	}
}
